import script from "./GmxProgressBar.vue?vue&type=script&setup=true&lang=js"
export * from "./GmxProgressBar.vue?vue&type=script&setup=true&lang=js"

import "./GmxProgressBar.vue?vue&type=style&index=0&id=5148a22c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5148a22c"]])

export default __exports__